// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sequenceblock-noscrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.sequenceblock-noscrollbar::-webkit-scrollbar {
    display: none;
}

.sequenceblockText {
    width:96%;
    height:90px;
    margin-left: 2%;
    margin-top:10px;
    text-align:justify;
    border-style:solid;
    border-color:#808080;
    border-width:1px;
    padding:3px;
    -webkit-user-select: text;
            user-select: text;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

}

.sequenceblockText::-webkit-scrollbar {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/sequenceblock.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;;AAE5B;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".sequenceblock-noscrollbar {\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.sequenceblock-noscrollbar::-webkit-scrollbar {\n    display: none;\n}\n\n.sequenceblockText {\n    width:96%;\n    height:90px;\n    margin-left: 2%;\n    margin-top:10px;\n    text-align:justify;\n    border-style:solid;\n    border-color:#808080;\n    border-width:1px;\n    padding:3px;\n    user-select: text;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n}\n\n.sequenceblockText::-webkit-scrollbar {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
